<template>
  <div>
    <my-table
      :data="data"
      :loading="loading"
      :headers="headers"
      :query="query"
      @edit="handleEdit"
      @search="handleSearch"
      @refresh="handleRefresh"
      @change-page="handleChangePage"
      @change-limit="handleChangeLimit"
      :editable="false"
    />
  </div>
</template>
<script>
import * as _ from 'lodash'
import listData from '../utils/listData'
import listMethods from '../utils/listMethods'
export default {
  data () {
    return {
      ...listData,
      listApiUrl: '/contracts/payments',
      headers: [{
        prop: 'paymentTypeId',
        type: 'lookup',
        tableName: 'payment_types',
        name: 'paymentType.name',
        caption: 'Гүйлгээний төрөл',
        width: '100px',
        color: 'paymentType.color',
        icon: 'paymentType.icon'
      }, {
        name: 'value',
        caption: 'Мөнгөн дүн',
        width: '100px',
        type: 'currency'
      }, {
        name: 'cashe.name',
        caption: 'Хэлбэр',
        width: '100px'
      }, {
        name: 'note',
        caption: 'Тайлбар'
      }, {
        name: 'paidAt',
        caption: 'Төлсөн огноо',
        type: 'Date',
        width: '100px'
      }, {
        name: 'contract.regNo',
        caption: 'Гэрээний дугаар',
        width: '100px'
      }, {
        prop: 'contract.statusId',
        type: 'lookup',
        tableName: 'contract_status',
        name: 'contract.status.name',
        caption: 'Төлөв',
        width: '100px',
        color: 'contract.status.color'
      }, {
        name: 'contract.customer.registerNum',
        caption: 'Регистрийн дугаар',
        width: '100px'
      }, {
        name: 'contract.customer.firstName',
        caption: 'Нэр',
        width: '130px'
      }, {
        name: 'createdAt',
        caption: 'Бүртгэсэн огноо',
        type: 'Date',
        width: '100px'
      }, {
        name: 'createdBy.firstName',
        caption: 'Бүртгэсэн хэрэглэгч',
        width: '110px'
      }],
      query: { page: 1, limit: 15, sort: [{ name: 'createdAt', type: 'DESC' }], search: [] }
    }
  },
  beforeMount () {
    this.getList()
  },
  beforeUnmount () {
    this.handleCancelToken()
  },
  methods: {
    ...listMethods,
    async handleEdit (id) {
      try {
        await this.showConfirm({ message: 'Та гэрээ рүү шилжих үү?' })
        const item = this.data[0].find(c => c.id === id)
        this.$router.push({ name: 'contracts-detail', params: { name: 'all', id: item.contract.id } })
      } catch (err) {
        this.handleError(err)
      }
    }
  }
}
</script>
<style>
.input-container input {
    border: none;
    box-sizing: border-box;
    outline: 0;
    padding: .75rem;
    position: relative;
    width: 100%;
}
input[type="date"]::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    color: transparent;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
}
</style>
